import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

@Component({
    selector: 'app-radio-button-item',
    templateUrl: './radio-button-item.component.html',
    styleUrls: ['./radio-button-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class RadioButtonItemComponent {

  @HostBinding('attr.role') role = 'button';
  @HostBinding('attr.tabindex') tabindex = '0';

  @Input() @HostBinding('class.selected') selected: boolean;
  

}
